import Api from '@/services/api/api/index.js'
import endpoints from './endpoint'

const fetch = (args) => {
  let params = new URLSearchParams();

  params.append('recording', args.video);
  params.append('calendar_id', args.calendar_id);

  return Api.get(endpoints.get('get')+'?'+params.toString());
}

export default {
  fetch
};
